export default "__VITE_ASSET__C20vFgA0__"